module.exports = __webpack_public_path__ + "static/img/store.32cb553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ucenter/store.png
// module id = 2385
// module chunks = 68